import React, { useState, useRef, useEffect, useCallback } from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import {
    Container,
    Spinner
} from 'react-bootstrap'

// react router
import { Link } from 'react-router-dom'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react toastify
import { toast } from 'react-toastify';

// includes
import EmailsFormContentView from './Includes/EmailsFormContentView'

// APIs
import { getEmailDetails, cancelGetEmailDetailsApi, getEmailEvents, cancelGetEmailEventsApi, editEmailTemplate } from 'utlis/Apis/Emails_API'

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon'

// messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    EMAIL_UPDATED_SUCCESSFULLY,
    ERROR_WHILE_UPDATING_EMAIL,
    ERROR_WHILE_GETTING_EMAIL_DETAILS,
} from 'utlis/AppMessages/AppMessages'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

function EditEmail(props) {
    // props
    const {
        authState,
        commonToken,
        sideBarVisibility,

        setGlobalLoading,

        match,
        location

    } = props

    // refs
    const submitButtonRef = useRef(null)

    // store url
    const [storeUrl] = useStoreUrl()

    // states
    const [emailId, setEmailId] = useState("")

    const [editButtonDisable, setEditButtonDisable] = useState(false)
    const [editButtonLoading, setEditButtonLoading] = useState(false)

    const [emailEvents, setEmailEvents] = useState([])
    const [email, setEmail] = useState({})

    const [emailTemplateId, setEmailTemplateId] = useState([])

    // function to get email events
    const getEmailEventsFunc = useCallback(() => {
        if (authState && emailId) {
            // global loading
            setGlobalLoading(true)

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // getting event id
            getEmailEvents(headers, emailId).then(res => {
                const emailEvents = res.data
                // global loading
                setGlobalLoading(false)

                // if request is success
                if (emailEvents.success) {
                    setEmailEvents(emailEvents.data.data)
                }

                // if request is not succeed
                if (emailEvents.error) {
                    console.log('Error occured while loading email events!', res)
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getEmailEvents `, err.message)

                // global loading
                setGlobalLoading(false)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            })
        }
    }, [authState, emailId, setGlobalLoading])

    // function to get email details
    const getEmailDetailsFunc = useCallback(() => {
        if (commonToken && emailId) {
            // global loading
            setGlobalLoading(true)

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // getting single email details
            getEmailDetails(headers, emailId).then(res => {
                const emailData = res.data

                // global loading
                setGlobalLoading(false)

                // if request is success
                if (emailData.success) {
                    setEmailTemplateId(emailData.data.template_id)
                    // setting the form fields
                    setEmail(emailData.data || {})
                }
                // if request is not succeed
                if (emailData.error) {
                    console.log(ERROR_WHILE_GETTING_EMAIL_DETAILS, res)

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(ERROR_WHILE_GETTING_EMAIL_DETAILS, {
                        autoClose: 3000,
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getEmailDetails `, err.message)

                // dismissing all the previous toasts first
                toast.dismiss();

                // global loading
                setGlobalLoading(false)

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            })

        }
    }, [commonToken, emailId, setGlobalLoading])

    // getting email events
    useEffect(() => {
        getEmailEventsFunc() // calling funciton to get email events

        return () => {
            // canceling email events api when user leaves the component
            cancelGetEmailEventsApi && cancelGetEmailEventsApi()
        }
    }, [getEmailEventsFunc])

    // geting form values from the url
    useEffect(() => {
        const locState = location?.state
        if (locState) {
            const emailData = locState.emailDetails
            console.log("emailData ", emailData);
            setEmailTemplateId(emailData.template_id)

            // setting the form fields
            setEmail(emailData)
        } else {
            getEmailDetailsFunc() // getting email details

            return () => {
                // canceling admin users api when user leaves the component
                cancelGetEmailDetailsApi && cancelGetEmailDetailsApi()
            }
        }

    }, [location, getEmailDetailsFunc])

    // setting email id
    useEffect(() => {
        const emailIdFromUrl = match.params;
        // setting user id from the url
        if (emailIdFromUrl) {
            setEmailId(emailIdFromUrl.id)
        }
    }, [match])

    // initial edit email form values
    const initialEditFormValues = {
        emailTemplateName: email?.template_title ?? "",
        emailEventName: email?.event_id ?? "",
        emailTo: email?.send_email_to ?? "",
        emailFrom: email?.email_from ?? "",
        emailSubject: email?.email_subject ?? "",
        emailCC: email?.cc_email ?? "",
        emailBCC: email?.bcc_email ?? "",
        emailContent: email?.email_body ?? "",
    }

    // handle edit email form validations
    const editFormValidationSchema = Yup.object({
        emailTemplateName: Yup.string().required('This field is required'),
        emailEventName: Yup.string().required('This field is required'),
        emailTo: Yup.string().required('This field is required'),
        emailFrom: Yup.string(),
        emailSubject: Yup.string().required('This field is required'),
        emailCC: Yup.string(),
        emailBCC: Yup.string(),
        emailContent: Yup.string().required('This field is required'),
    })

    // handle edit email form submmision
    const onEmailFormSubmit = values => {
        if (values) {
            // global loading
            setGlobalLoading(true)

            // disabling the button and enabling loading
            setEditButtonDisable(true)
            setEditButtonLoading(true)

            // saving the email in the database
            const dataToBeSaved = {
                template_id: emailTemplateId,
                template_title: values.emailTemplateName,
                email_subject: values.emailSubject,
                email_from: values.emailFrom,
                cc_email: values.emailCC,
                bcc_email: values.emailBCC,
                email_body: values.emailContent,
                send_email_to: values.emailTo,
                event_id: values.emailEventName,
            }

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // updating the user details from the database
            editEmailTemplate(headers, dataToBeSaved).then(res => {
                // global loading
                setGlobalLoading(false)

                // enabling the button and disabling loading
                setEditButtonDisable(false)
                setEditButtonLoading(false)

                const emailUpdated = res.data

                // if successfully created
                if (emailUpdated.success) {

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing success message
                    toast.success(EMAIL_UPDATED_SUCCESSFULLY, {
                        autoClose: 3000
                    })
                }

                // if some error
                if (emailUpdated.error) {
                    console.log(ERROR_WHILE_UPDATING_EMAIL, res)
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(ERROR_WHILE_UPDATING_EMAIL, {
                        autoClose: 3000
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} editEmailTemplate `, err.message)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // global loading
                        setGlobalLoading(false)

                        // enabling the button and disabling loading
                        setEditButtonDisable(false)
                        setEditButtonLoading(false)
                    }
                })
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialEditFormValues,
        validationSchema: editFormValidationSchema,
        onSubmit: onEmailFormSubmit,
        enableReinitialize: true
    })

    // html editor
    const getHTML_editorResult = (data) => {
        // setting email content
        formik.setFieldValue("emailContent", data)
    }

    // handle button submission
    const handleFormSubmission = (ev) => {
        ev.preventDefault()

        // triggering click on submit button
        submitButtonRef.current.click()
    }

    return (
        <section id="app-emails__edit-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-emails__edit-details">
                    {/* BACK BUTTON WRAPPER */}
                    <div className="back-button-wrapper mb-2">
                        <Link to={storeUrl + "/settings/emails"} className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15">
                            <FeatherIcon
                                icon="arrow-left"
                                size="14"
                                className="icon me-1" />
                            <span>Back to Email Templates</span>
                        </Link>
                    </div>

                    {/* HEADING WRAPPER */}
                    <div className="app-header-wrapper mb-3">
                        {/* heading */}
                        <p className="app-heading text-capitalize">Edit Email</p>
                        <p className="app-desc">
                            Edit an email for different events like forgot password, create account etc.
                        </p>
                    </div>
                    {/* 1053753 */}

                    {/* CONTENT WRAPPER */}
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        <div className="app-content-container">
                            <EmailsFormContentView
                                formik={formik}

                                emailEvents={emailEvents}

                                getHTML_editorResult={getHTML_editorResult}
                            />

                            {/* app card : bottom-bar */}
                            <div className={`app-card page-bottom-action-btns ${sideBarVisibility ? "" : "sidebar-expanded"}`}>
                                <div className="app-card-content bg-white border-top st-border-light d-flex align-items-center justify-content-end">
                                    <Link to={storeUrl + "/settings/emails"} className="st-btn st-btn-link no-min-width d-flex align-items-center justify-content-center me-1">
                                        Cancel
                                    </Link>
                                    <button
                                        type="submit"
                                        className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(editButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                        disabled={editButtonDisable || Object.keys(formik.errors).length}
                                        onClick={handleFormSubmission}>
                                        {
                                            editButtonLoading ? (
                                                <Spinner animation="border" size="sm" />
                                            ) : (
                                                <span>Save Changes</span>
                                            )
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
                    </form>

                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
        commonToken: state.auth.commonToken,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(EditEmail)